import React from 'react'
import { useAppLocale } from '../i18n/localeUtils'
import { Typography } from '@mui/material'
import { formatDateYYYYMMDD } from '../packages/utils/numberFormatters'

interface DateRangeProps {
    endDate?: string | null
    startDate?: string | null
}

function DateRange({ endDate, startDate }: DateRangeProps) {
    const { language: locale } = useAppLocale()

    if (!endDate || !startDate) return null
    const formatedStartDate = formatDateYYYYMMDD(startDate, { locale })
    const formatedEndDate = formatDateYYYYMMDD(endDate, { locale })
    const isOneDayRange = formatedEndDate === formatedStartDate

    return (
        <Typography variant='caption' color='textSecondary' sx={{ fontVariantNumeric: 'tabular-nums' }}>
            {isOneDayRange && formatedStartDate}
            {!isOneDayRange && `${formatedStartDate} => ${formatedEndDate}`}
        </Typography>
    )
}

export default DateRange
